import { render, staticRenderFns } from "./empty-page-with-layout.vue?vue&type=template&id=eb86a99c&"
import script from "./empty-page-with-layout.ts?vue&type=script&lang=ts&"
export * from "./empty-page-with-layout.ts?vue&type=script&lang=ts&"
import style0 from "./empty-page-with-layout.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports